import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Route, Switch, useLocation, useHistory } from "react-router-dom";
import "./css/App.css";
import { getCurrentUser, logout } from "./reducers/login";
import { bindActionCreators } from "redux";
import Home from "./components/Home";
import Header from "./components/Header";
import NA from "./components/NA";
import NoAccess from "./components/NoAccess";
import AuthRoute from './utils/AuthRoute'
import LessonsGroupListContainer from "./containers/RoleBased/LessonsGroupListContainer";
import CodeWarsGroupListContainer from "./containers/RoleBased/CodeWarsGroupListContainer";
import LessonsContainer from "./containers/RoleBased/LessonsContainer";
import SearchContainer from "./containers/RoleBased/SearchContainer";
import CodeWarsContainer from "./containers/RoleBased/CodeWarsContainer";
import RegistrationContainer from "./containers/Auth/RegistrationContainer";
import LoginContainer from "./containers/Auth/LoginContainer";
import RemindPasswordContainer from "./containers/Auth/RemindPasswordContainer";
import UpdateUserContainer from "./containers/RoleBased/UpdateUserContainer";
import ProjectsContainer from "./containers/RoleBased/ProjectsContainer";
import UnauthRoute from "./utils/UnauthRoute";
import UpdateLessonContainer from "./containers/RoleBased/UpdateLessonContainer";
import Footer from "./components/Footer";
import { sourceClick } from "./api/source";
import TrackingContainer from "./containers/RoleBased/TrackingContainer";
import { queryConfig } from "./config";
import { QueryClientProvider, QueryClient } from "react-query";

const App = (props) => {
  const queryClient = new QueryClient(queryConfig)
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get('source');
  const pathname = location.pathname;

  useEffect(() => {
    if (source) {
      localStorage.setItem('source', source);
      if (pathname === '/info') {
        sourceClick(source).then(() => {
          window.location.replace("https://www.techstart.dev");
        });
      } else if (pathname === '/info/free') {
        sourceClick(source).then(() => {
          window.location.replace("https://www.techstart.dev/free");
        });
      } else {
        queryParams.delete('source');
        const search = queryParams.toString();
        history.replace({ search });
      }
    } else if (pathname === '/info' || pathname === '/info/free') {
      history.push('/login');
    }
    // eslint-disable-next-line
  }, [source, pathname]);

  return (
    <QueryClientProvider client={queryClient}>
      <div className='main'>
        {props.currentUser && <Header {...props} />}
        <div className={props.currentUser && "content"}>
          <Switch>
            <AuthRoute path="/" exact component={Home} />
            <AuthRoute path="/lessons" exact component={LessonsGroupListContainer} />
            <AuthRoute path="/lessons/:group" exact component={LessonsContainer} />
            <AuthRoute path="/codewars" exact component={CodeWarsGroupListContainer} />
            <AuthRoute path="/codewars/:group" component={CodeWarsContainer} />
            <AuthRoute path="/projects" exact component={ProjectsContainer} />
            <AuthRoute path="/user/search" component={SearchContainer} />
            <AuthRoute path="/tracking" component={TrackingContainer} />
            <AuthRoute path="/updateUser/:userId" component={UpdateUserContainer} />
            <AuthRoute path="/lesson/add" component={UpdateLessonContainer} />
            <AuthRoute path="/lesson/update/:id" component={UpdateLessonContainer} />
            <AuthRoute path="/noAccess" exact component={NoAccess} />
            <UnauthRoute path="/registration" exact component={RegistrationContainer} />
            <UnauthRoute path="/login" exact component={LoginContainer} />
            <UnauthRoute path="/info" component={() => <div />} />
            <UnauthRoute
              path="/remind-password"
              exact
              component={RemindPasswordContainer}
            />

            {/* Else*/}
            <Route component={NA} />
          </Switch>
        </div>
        {props.currentUser && <Footer />}
      </div>
    </QueryClientProvider>
  );
};

const mapStateToProps = (state) => ({
  path: state.path,
  currentUser: getCurrentUser(state),
});

const actions = (dispatch, props) => ({
  logout: bindActionCreators(logout, dispatch),
});

export default connect(mapStateToProps, actions)(App);
